import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";
import { SxProps } from "@mui/material";

interface UseFormSelectDrive1Props {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectDrive1: React.FC<UseFormSelectDrive1Props> = ({
  control,
  name,
  sx = {}
}) => {
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: '', label: ''},
        {value: 'FF', label: 'FF'},
        {value: 'FR', label: 'FR'},
      ]}
      sx={{
        width: '80px',
        ...sx,
      }}
    />
  )
}